import { render, staticRenderFns } from "./myProduct.vue?vue&type=template&id=3c9218b6&scoped=true"
import script from "./myProduct.vue?vue&type=script&lang=js"
export * from "./myProduct.vue?vue&type=script&lang=js"
import style0 from "./myProduct.vue?vue&type=style&index=0&id=3c9218b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9218b6",
  null
  
)

export default component.exports